export default {
      id: "ic-back-white-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic-back-white-usage",
      toString: function () {
        return this.url;
      }
    }